// extracted by mini-css-extract-plugin
module.exports = {"btnConnectWallet":"BtnConnectWallet_btnConnectWallet__dOho4"};